module.exports = __webpack_public_path__ + "static/media/mv.f1beedaa.svg";